import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07f91705"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "p-inputgroup",
  style: {"padding-top":"4px","position":"relative"}
}
const _hoisted_2 = {
  key: 0,
  class: "p-inputgroup-addon",
  style: {"cursor":"default"}
}
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = ["id"]
const _hoisted_6 = ["for"]
const _hoisted_7 = { style: {"position":"absolute","right":"10px","top":"12px"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-times",
  style: {"font-size":"0.7rem"}
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.icon)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createElementVNode("i", {
            class: _normalizeClass($props.icon)
          }, null, 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, [
        ($props.type === 'text')
          ? (_openBlock(), _createBlock(_component_InputText, {
              key: 0,
              id: $props.autofillName ?? $data.itc,
              modelValue: $data.curValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.curValue) = $event)),
              style: {"padding-right":"30px"},
              onInput: $options.inputChanged
            }, null, 8, ["id", "modelValue", "onInput"]))
          : _createCommentVNode("", true),
        ($props.type === 'number')
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              id: $props.autofillName ?? $data.itc,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.curValue) = $event)),
              class: _normalizeClass([{'p-filled': !!$data.curValue}, "p-inputtext p-component hiddenArrows"]),
              type: "number",
              onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.inputChanged && $options.inputChanged(...args))),
              onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.numberKeyDown && $options.numberKeyDown(...args)))
            }, null, 42, _hoisted_5)), [
              [_vModelText, $data.curValue]
            ])
          : _createCommentVNode("", true),
        _createElementVNode("label", {
          for: $props.autofillName ?? $data.itc,
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($options.labelClicked && $options.labelClicked(...args)))
        }, _toDisplayString($props.label), 9, _hoisted_6)
      ])
    ]),
    _withDirectives(_createElementVNode("span", _hoisted_7, [
      _createElementVNode("a", {
        style: {"border":"none","outline":"none","position":"relative"},
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($options.clearInput && $options.clearInput(...args)))
      }, _hoisted_9)
    ], 512), [
      [_vShow, $props.showClearButton && $data.curValue]
    ])
  ]))
}